import UserApi from 'app/api/UserApi';
import { useUserDateFormat } from "../core/useFormatUserDate";
import { format } from 'date-fns';
import { UserRole } from 'legoland-sdk/dist/experimental';
import { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';
import { Box, Button, Tooltip, tombac, useToasts } from 'tombac';
import { AddIcon, DeleteIcon, EditIcon, PinIcon, SaveIcon } from 'tombac-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function NoteList(_ref) {
  let {
    notes,
    role,
    email,
    fetchNotes
  } = _ref;
  const [edit, setEdit] = useState(null);
  const [currentEdited, setCurrentEdited] = useState(null);
  const [newNote, setNewNote] = useState('');
  const dateFormat = useUserDateFormat({
    withTime: true
  });
  const {
    addToast
  } = useToasts();
  const createNote = async () => {
    try {
      await UserApi.createUserNotes(email, {
        content: newNote
      });
      fetchNotes();
      setNewNote('');
    } catch (e) {
      addToast('Could not save the note.', 'danger', {
        content: 'Please try again later or contact MOVE support.'
      });
    }
  };
  const pinNote = async (id, pinned, content) => {
    await UserApi.updateUserNotes(email, {
      id: id,
      pinned,
      content
    });
    fetchNotes();
  };
  const deleteNote = async id => {
    await UserApi.deleteUserNotes(email, id);
    fetchNotes();
  };
  const updateNote = async id => {
    await UserApi.updateUserNotes(email, {
      id: id,
      content: currentEdited.content
    });
    fetchNotes();
    setEdit(null);
    setCurrentEdited(null);
  };
  const editNote = id => {
    toggleEdit(id);
    const currentNote = notes.filter(note => note.id === id)[0];
    setCurrentEdited(currentNote);
  };
  const toggleEdit = useCallback(id => {
    if (edit === id) {
      setEdit(null);
    } else {
      setEdit(id);
    }
  }, [setEdit, edit]);
  return /*#__PURE__*/_jsxs("div", {
    "data-sentry-component": "NoteList",
    "data-sentry-source-file": "NoteList.tsx",
    children: [(role === UserRole.Admin || role === UserRole.Support) && /*#__PURE__*/_jsxs(NoteForm, {
      $w: "100%",
      children: [/*#__PURE__*/_jsx(TextAreaStyled, {
        placeholder: "Add a note...",
        value: newNote,
        onChange: event => setNewNote(event.currentTarget.value)
      }), /*#__PURE__*/_jsx(Box, {
        $display: "flex",
        $justifyContent: "flex-end",
        $mt: "2sp",
        $mb: "4sp",
        children: /*#__PURE__*/_jsx(StyledButton, {
          variant: "primary",
          onClick: createNote,
          prepend: /*#__PURE__*/_jsx(AddIcon, {}),
          disabled: !newNote,
          children: "Add note"
        })
      })]
    }), notes.map(note => {
      return /*#__PURE__*/_jsxs(NoteElement, {
        editMode: edit !== note.id,
        children: [edit !== note.id && /*#__PURE__*/_jsxs(NoteContent, {
          children: [note.pinned && /*#__PURE__*/_jsx(NoteElementPinnedInfo, {
            children: "Pinned note"
          }), note.content, /*#__PURE__*/_jsxs(NoteElementFooter, {
            children: ["Added by ", note.writer, " at", ' ', format(Date.parse(note.createdAt.toString()), dateFormat)]
          })]
        }), edit === note.id && /*#__PURE__*/_jsx(NoteForm, {
          children: /*#__PURE__*/_jsx(TextAreaStyled, {
            value: currentEdited.content,
            onChange: event => setCurrentEdited({
              ...currentEdited,
              content: event.currentTarget.value
            })
          })
        }), (role === UserRole.Admin || role === UserRole.Support) && /*#__PURE__*/_jsx(Buttons, {
          children: edit !== note.id ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Tooltip, {
              variant: "inverted",
              placement: "top",
              closeOnOutsideClick: false,
              content: note.pinned ? 'Unpin note' : 'Pin note',
              children: _ref2 => {
                let {
                  ref,
                  open,
                  close
                } = _ref2;
                return /*#__PURE__*/_jsx(Button, {
                  ref: ref,
                  onMouseEnter: open,
                  onMouseLeave: close,
                  shape: "circle",
                  variant: "flat",
                  onClick: () => pinNote(note.id, !note.pinned, note.content),
                  children: /*#__PURE__*/_jsx(PinIcon, {
                    color: note.pinned ? '#00AAFF' : undefined,
                    fill: note.pinned ? '#00AAFF' : 'transparent',
                    style: {
                      width: '20px',
                      height: '20px'
                    }
                  })
                });
              }
            }), /*#__PURE__*/_jsx(Tooltip, {
              variant: "inverted",
              placement: "top",
              closeOnOutsideClick: false,
              content: "Edit note",
              children: _ref3 => {
                let {
                  ref,
                  open,
                  close
                } = _ref3;
                return /*#__PURE__*/_jsx(Button, {
                  ref: ref,
                  onMouseEnter: open,
                  onMouseLeave: close,
                  shape: "circle",
                  variant: "flat"
                  // onClick={() => toggleEdit(note.id)}
                  ,
                  onClick: () => {
                    editNote(note.id);
                  },
                  children: /*#__PURE__*/_jsx(EditIcon, {})
                });
              }
            }), /*#__PURE__*/_jsx(Tooltip, {
              variant: "inverted",
              placement: "top",
              closeOnOutsideClick: false,
              content: "Delete note",
              children: _ref4 => {
                let {
                  ref,
                  open,
                  close
                } = _ref4;
                return /*#__PURE__*/_jsx(Button, {
                  ref: ref,
                  onMouseEnter: open,
                  onMouseLeave: close,
                  shape: "circle",
                  variant: "flat",
                  onClick: () => deleteNote(note.id),
                  children: /*#__PURE__*/_jsx(DeleteIcon, {})
                });
              }
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Button, {
              $marginRight: "1vw",
              onClick: () => editNote(note.id),
              children: "Cancel"
            }), /*#__PURE__*/_jsx(StyledButton, {
              variant: "tertiary",
              prepend: /*#__PURE__*/_jsx(SaveIcon, {}),
              onClick: () => updateNote(note.id),
              disabled: !currentEdited?.content,
              children: "Save"
            })]
          })
        })]
      }, note.id);
    })]
  });
}
const NoteForm = styled.div.withConfig({
  displayName: "NoteList__NoteForm"
})(["margin-bottom:20px;"]);
const Buttons = styled.div.withConfig({
  displayName: "NoteList__Buttons"
})(["display:flex;align-items:right;justify-content:right;"]);
const NoteElement = styled.div.withConfig({
  displayName: "NoteList__NoteElement"
})(["margin-bottom:", ";padding-bottom:", ";border-bottom:1px solid ", ";", ""], tombac.space(4), tombac.space(4), tombac.color('neutral', 500), _ref5 => {
  let {
    editMode
  } = _ref5;
  return editMode && css(["display:flex;justify-content:space-between;"]);
});
const NoteElementFooter = styled.div.withConfig({
  displayName: "NoteList__NoteElementFooter"
})(["color:", ";font-size:12px;margin-top:", ";"], tombac.color('neutral', 600), tombac.space(1));
const NoteElementPinnedInfo = styled.div.withConfig({
  displayName: "NoteList__NoteElementPinnedInfo"
})(["font-family:'Proxima Nova';font-weight:700;color:", ";font-size:12px;width:77px;height:20px;background-color:", ";padding:5px;display:flex;justify-content:center;align-items:center;border-radius:3px;margin-bottom:", ";"], tombac.color('accent', 500), tombac.color('accent', 200), tombac.space(1));
const NoteContent = styled.div.withConfig({
  displayName: "NoteList__NoteContent"
})(["padding-right:", ";white-space:pre-wrap;"], tombac.space(1));
const TextAreaStyled = styled.textarea.withConfig({
  displayName: "NoteList__TextAreaStyled"
})(["", " width:100%;display:block;border:1px solid ", ";border-radius:10px;height:90px;padding:", ";resize:none;&:focus-visible{outline:none;border:1px solid ", ";}"], tombac.text, tombac.color('neutral', 400), tombac.space(2), tombac.color('accent', 500));
const StyledButton = styled(Button).withConfig({
  displayName: "NoteList__StyledButton"
})(["&:disabled svg{color:", ";}"], tombac.color('neutral', 500));